import { selectCommercialPriceAside } from './selectCommercialPriceAside';
import { selectResidentialPriceAside } from './selectResidentialPriceAside';
import { IState } from '../../store';
import { getOfferType, isCommercial } from '../../utils/offer_type';

export const selectPriceAside = (state: IState) => {
  const {
    offerData: { offer },
    knAuctionCompanies,
  } = state;
  const offerType = getOfferType(offer);
  const isPriceAuction = offer.cianUserId && knAuctionCompanies.includes(offer.cianUserId);

  if (isCommercial(offerType)) {
    if (isPriceAuction) {
      return null;
    }

    return selectCommercialPriceAside(state);
  }

  return selectResidentialPriceAside(state);
};
